import { useEffect, useState } from 'react';
import { getPage } from '@/services/terms-and-conditions/terms-and-conditions.service';
import type { TermsAndConditionsPage } from '@edwin-group/cj-graphql/generated/graphql';
import DefaultContentTemplatePage from '../default-content-template';

const TermsAndConditionsPageComponent = () => {
  const [page, setPage] = useState<TermsAndConditionsPage | null>(null);

  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    (async () => {
      setLoading(true);

      const pageResponse = await getPage();

      setPage(pageResponse.page);
      setLoading(false);
    })();
  }, []);

  const template = page?.DefaultContentTemplate || null;

  if (loading) {
    return null;
  }

  return (
    <>
      <DefaultContentTemplatePage template={template} title={page?.title || 'Back to the Homepage'} />
    </>
  );
};

export default TermsAndConditionsPageComponent;
